import { axiosInstance } from "config/axiosConfig";

export const getServerStatus = async () => {
  const response = await axiosInstance.get("/server/status");
  return response.data;
};
